export default __webpack_public_path__ + "static/media/download.ea388a9e.png";